module.exports = __webpack_public_path__ + "static/media/site.ae6f3331.webmanifest";